var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", [
      _c("h3", [_vm._v("图表介绍")]),
      _vm._v(" "),
      _c("p", [_vm._v("RadialBar，玉玦图。")]),
      _vm._v(" "),
      _c("h3", [_vm._v("attrs")]),
      _vm._v(" "),
      _c("table", [
        _c("thead", [
          _c("tr", [
            _c("th", [_vm._v("属性名")]),
            _vm._v(" "),
            _c("th", [_vm._v("类型")]),
            _vm._v(" "),
            _c("th", [_vm._v("默认值")]),
            _vm._v(" "),
            _c("th", [_vm._v("描述")])
          ])
        ]),
        _vm._v(" "),
        _c("tbody", [
          _c("tr", [
            _c("td", [_vm._v("min")]),
            _vm._v(" "),
            _c("td", [_vm._v("Number")]),
            _vm._v(" "),
            _c("td", [_c("code", { pre: true }, [_vm._v("0")])]),
            _vm._v(" "),
            _c("td", [_vm._v("最小值")])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [_vm._v("max")]),
            _vm._v(" "),
            _c("td", [_vm._v("Number")]),
            _vm._v(" "),
            _c("td", [_c("code", { pre: true }, [_vm._v("1")])]),
            _vm._v(" "),
            _c("td", [_vm._v("最大值")])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [_vm._v("startAngle")]),
            _vm._v(" "),
            _c("td", [_vm._v("Number")]),
            _vm._v(" "),
            _c("td", [_vm._v("-90")]),
            _vm._v(" "),
            _c("td", [_vm._v("起始角度")])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [_vm._v("endAngle")]),
            _vm._v(" "),
            _c("td", [_vm._v("Number")]),
            _vm._v(" "),
            _c("td", [_vm._v("270")]),
            _vm._v(" "),
            _c("td", [_vm._v("结束角度")])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [_vm._v("radius")]),
            _vm._v(" "),
            _c("td", [_vm._v("Number")]),
            _vm._v(" "),
            _c("td", [_c("code", { pre: true }, [_vm._v("0.8")])]),
            _vm._v(" "),
            _c("td", [_vm._v("外半径比例")])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [_vm._v("innerRadius")]),
            _vm._v(" "),
            _c("td", [_vm._v("Number")]),
            _vm._v(" "),
            _c("td", [_c("code", { pre: true }, [_vm._v("0")])]),
            _vm._v(" "),
            _c("td", [_vm._v("内半径比例")])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [_vm._v("strokeBgcolor")]),
            _vm._v(" "),
            _c("td", [_vm._v("String")]),
            _vm._v(" "),
            _c("td", [_c("code", { pre: true }, [_vm._v("#eee")])]),
            _vm._v(" "),
            _c("td", [_vm._v("背景圆弧的背景色")])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [_vm._v("lineWidth")]),
            _vm._v(" "),
            _c("td", [_vm._v("Number")]),
            _vm._v(" "),
            _c("td", [_c("code", { pre: true }, [_vm._v("5")])]),
            _vm._v(" "),
            _c("td", [_vm._v("弧线宽度")])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("h3", [_vm._v("style")]),
      _vm._v(" "),
      _c("p", [_vm._v("组件中可以自定义 css 属性的元素如下表：")]),
      _vm._v(" "),
      _c("table", [
        _c("thead", [
          _c("tr", [
            _c("th", [_vm._v("名称")]),
            _vm._v(" "),
            _c("th", [_vm._v("基础类型")]),
            _vm._v(" "),
            _c("th", [_vm._v("描述")])
          ])
        ]),
        _vm._v(" "),
        _c("tbody", [
          _c("tr", [
            _c("td", [_vm._v("arc")]),
            _vm._v(" "),
            _c("td", [_vm._v("线")]),
            _vm._v(" "),
            _c("td", [_vm._v("弧线样式")])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [_vm._v("arc:hover")]),
            _vm._v(" "),
            _c("td", [_vm._v("线")]),
            _vm._v(" "),
            _c("td", [_vm._v("弧线鼠标hover样式")])
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }